<template>
  <div class="personal mobile-personal">

    <div v-if="isPhone" class="phone-personal">
      <a-tabs v-model="activeKey" :tabPosition="tabPosition">
        <a-tab-pane tab="我的主页" key="1">
          <!--          顶部姓名头像、联系客服 会员特权-->
          <header class="mobile-header">
            <div class="avatar-name-box">
              <div class="avatar">
                <a-upload
                    name="file"
                    :multiple="true"
                    action="/api/pcUser/updata/userAvatar"
                    :headers="headers"
                    @change="handleChange"
                    :beforeUpload="beforeUpload"
                    :showUploadList="false"
                >
                  <a-avatar :src="userInfo.avatarUrl" style="margin-right: 8px"  :size="32" icon="user" />
                </a-upload>
                <span @click="changeNickname(1)">{{ userInfo.nickname }}</span>
              </div>
              <div class="custom-service">
                <img src="@assets/img/person/customer-service.png" alt="">
                <span @click="showServiceNum=true">联系客服</span>
              </div>
            </div>
            <div class="member-msg-box">
              <img :src="memberDisplay().icon" alt="">
              <div class="member-prerogative">
                <div>会员特权</div>
                <div v-if="userInfo.memberFlag == 0">专属标识、全栈课程、技术交流群等</div>
                <div v-else>会员到期时间：{{ userInfo.member.expiryTime }}</div>
              </div>
              <button @click="$router.push('/other/member-ship')">
                {{ userInfo.memberFlag == 0 ? '立即开通' : '立即续费' }}
              </button>
            </div>
          </header>
          <div class="bottom-container">
            <div class="setting-box">
              <div @click="changeNickname(2)">
                <img src="@assets/img/person/phone-icon.png" alt="">
                手机号设置
                <a-icon type="right"></a-icon>
              </div>
            </div>
            <div class="setting-box">
              <div @click="changeNickname(3)">
                <img src="@assets/img/person/password-icon.png" alt="">
                密码设置
                <a-icon type="right"></a-icon>
              </div>
            </div>
            <button @click="logout">退出登录</button>
          </div>

          <div class="rightbox">
            <div class="contact-customer-service">
              <a-modal
                  :footer="null"
                  :closable="false"
                  :visible="showServiceNum"
                  :confirmLoading="confirmLoading"
              >
                <div class="num-box">
                  <div class="contact-service">联系客服</div>
                  <div @click="callNum()"><img src="@assets/img/person/call-icon.png" alt="">{{ phoneNum.dictLabel }}
                  </div>
                  <div @click="copy(item.dictValue)" v-for="(item,index) in qqList" :key="index"><img
                      src="@assets/img/person/qq-icon.png" alt="">{{ item.dictValue.split(',')[0] }}
                  </div>
                  <img @click="showServiceNum=false" class="close-icon" src="@assets/img/person/circular-close.png"
                       alt="">
                </div>

              </a-modal>
            </div>

            <a-modal
                :cancelText="cancelText"
                :footer="null"
                :closable="false"
                :okText="okText"
                :visible="showNickname"
                :confirmLoading="confirmLoading"
                @cancel="handleCancel"
            >
              <div class="setting-phone-num">
                <h4>昵称设置</h4>
                <a-input placeholder="请输入新昵称！" maxLength="8"  v-model="newUserInfo.nickname"/>
                <div class="phone-setting-footer">
                  <button @click="handleCancel">取消</button>
                  <button @click="handleOk">确认</button>
                </div>
              </div>
            </a-modal>

            <a-modal
                :cancelText="cancelText"
                :okText="okText"
                :closable="false"
                :visible="showMobile"
                @ok="changePhone"
                :confirmLoading="confirmLoading"
                :footer="null"
            >
              <div class="setting-phone-num">
                <h4>手机号设置</h4>
                <div class="phone-num-box">
                  <a-input placeholder="请输入新手机号！" v-model="newUserInfo.mobile"/>
                  <a-button type="primary" @click="sendCode" :disabled=show>{{ countText }}</a-button>
                </div>
                <a-input placeholder="请输入验证码！" v-model="newUserInfo.code"/>
                <div class="phone-setting-footer">
                  <button @click="handleCancel">取消</button>
                  <button @click="changePhone">确认</button>
                </div>

              </div>
            </a-modal>


            <a-modal
                :cancelText="cancelText"
                :okText="okText"
                :visible="showPassword"
                @ok="changePassword"
                :closable="false"
                :footer="null"
                :confirmLoading="confirmLoading"
            >
              <div class="setting-phone-num">
                <h4>密码设置</h4>
                <div v-if="isPasswordModify">
                  <a-input placeholder="请输入旧密码" type="password" style="margin: 10px 0"
                           v-model="newUserInfo.oldPassword"/>
                  <a-input placeholder="请输入新密码" type="password" style="margin: 10px 0"
                           v-model="newUserInfo.newPassword"/>
                  <a-input placeholder="请再次输入新密码" type="password" style="margin: 10px 0"
                           v-model="newUserInfo.checkNewPassword"/>
                </div>
                <div v-else>
                  <div class="phone-num-box">
                    <a-input placeholder="请输入手机号！" v-model="newUserInfo.mobile"/>
                    <a-button type="primary" @click="sendCode" :disabled=show>{{ countText }}</a-button>
                  </div>
                  <a-input placeholder="请输入验证码！"
                           v-model="newUserInfo.code"/>
                  <a-input placeholder="请输入新密码" type="password"
                           v-model="newUserInfo.newPassword"/>
                  <a-input placeholder="请再次输入新密码" type="password"
                           v-model="newUserInfo.checkNewPassword"/>
                </div>
                <div class="password-modify-box">
                    <span @click="switchModifyPassword">
                      {{ isPasswordModify ? '验证码修改' : '原密码修改' }}
                    </span>
                </div>
                <div class="phone-setting-footer">
                  <button @click="handleCancel">取消</button>
                  <button @click="changePassword">确认</button>
                </div>

              </div>


            </a-modal>
          </div>
        </a-tab-pane>

        <a-tab-pane tab="我的课程" key="2">
          <myCourse></myCourse>
        </a-tab-pane>

        <a-tab-pane tab="我的订单" key="3">
          <myOrder></myOrder>
        </a-tab-pane>
      </a-tabs>
    </div>

    <div v-else class="box">
      <a-tabs v-model="activeKey" :tabPosition="tabPosition">
        <a-tab-pane tab="我的主页" key="1">
          <div class="rightbox">
            <header>个人信息</header>
            <div class="myInformation">
              <div class="informationList">
                昵称 <a @click="changeNickname(1)">修改</a> <br>
                <span v-if="!isHaveUserInfo"> <a-skeleton active :paragraph="{rows:1,width:'30%'}"
                                                          :title="false"/></span>
                <span v-else>{{ userInfo.nickname }}</span>
              </div>
              <div class="informationList">
                手机号 <a @click="changeNickname(2)">修改</a> <br>
                <span v-if="!isHaveUserInfo"> <a-skeleton active :paragraph="{rows:1,width:'30%'}"
                                                          :title="false"/></span>
                <span v-else>{{ userInfo.mobile }}</span>
              </div>
              <a-modal
                  :cancelText="cancelText"
                  :footer="null"
                  :closable="false"
                  :okText="okText"
                  :visible="showNickname"
                  :confirmLoading="confirmLoading"
                  @cancel="handleCancel"
              >
                <div class="setting-phone-num">
                  <h4>昵称设置</h4>
                  <a-input placeholder="请输入新昵称！" maxLength="8" v-model="newUserInfo.nickname"/>
                  <div class="phone-setting-footer">
                    <button @click="handleCancel">取消</button>
                    <button @click="handleOk">确认</button>
                  </div>
                </div>
              </a-modal>

              <a-modal
                  :cancelText="cancelText"
                  :okText="okText"
                  :closable="false"
                  :visible="showMobile"
                  @ok="changePhone"
                  :confirmLoading="confirmLoading"
                  :footer="null"
              >
                <div class="setting-phone-num">
                  <h4>手机号设置</h4>
                  <div class="phone-num-box">
                    <a-input placeholder="请输入新手机号！" v-model="newUserInfo.mobile"/>
                    <a-button type="primary" @click="sendCode" :disabled=show>{{ countText }}</a-button>
                  </div>
                  <a-input placeholder="请输入验证码！" v-model="newUserInfo.code"/>
                  <div class="phone-setting-footer">
                    <button @click="handleCancel">取消</button>
                    <button @click="changePhone">确认</button>
                  </div>

                </div>
              </a-modal>

              <div class="informationList">
                密码 <a @click="changeNickname(3)">修改</a> <br>
                <span v-if="!isHaveUserInfo"> <a-skeleton active :paragraph="{rows:1,width:'30%'}"
                                                          :title="false"/></span>
                <span v-else> ******</span>
              </div>
              <a-modal
                  :cancelText="cancelText"
                  :okText="okText"
                  :visible="showPassword"
                  @ok="changePassword"
                  :closable="false"
                  :footer="null"
                  :confirmLoading="confirmLoading"
              >
                <div class="setting-phone-num">
                  <h4>密码设置</h4>
                  <div v-if="isPasswordModify">
                    <a-input placeholder="请输入旧密码" type="password" style="margin: 10px 0"
                             v-model="newUserInfo.oldPassword"/>
                    <a-input placeholder="请输入新密码" type="password" style="margin: 10px 0"
                             v-model="newUserInfo.newPassword"/>
                    <a-input placeholder="请再次输入新密码" type="password" style="margin: 10px 0"
                             v-model="newUserInfo.checkNewPassword"/>
                  </div>
                  <div v-else>
                    <div class="phone-num-box">
                      <a-input placeholder="请输入新手机号！" v-model="newUserInfo.mobile"/>
                      <a-button type="primary" @click="sendCode" :disabled=show>{{ countText }}</a-button>
                    </div>
                    <a-input placeholder="请输入验证码！"
                             v-model="newUserInfo.code"/>
                    <a-input placeholder="请输入新密码" type="password"
                             v-model="newUserInfo.newPassword"/>
                    <a-input placeholder="请再次输入新密码" type="password"
                             v-model="newUserInfo.checkNewPassword"/>
                  </div>
                  <div class="password-modify-box">
                    <span @click="switchModifyPassword">
                      {{ isPasswordModify ? '验证码修改' : '原密码修改' }}
                    </span>
                  </div>
                  <div class="phone-setting-footer">
                    <button @click="handleCancel">取消</button>
                    <button @click="changePassword">确认</button>
                  </div>

                </div>


              </a-modal>

              <div>
                                <span v-if="!isHaveUserInfo"> <a-skeleton active :paragraph="{rows:1,width:'30%'}"
                                                                          :title="false"/></span>
                <span v-else>
                                     <img :src="imageUrl || defaultImg" alt="" style="width: 200px;height: 200px"
                                          :onerror="defaultImg">
                                </span>
                <br>
                <a-upload
                    name="file"
                    action="/api/pcUser/updata/userAvatar"
                    :headers="headers"
                    @change="handleChange"
                    :beforeUpload="beforeUpload"
                    :showUploadList="false"
                    :loading="uploading"
                >
                  <a-button>
                    <a-icon type="upload"/>
                    更改头像
                  </a-button>
                </a-upload>
              </div>
            </div>
          </div>
        </a-tab-pane>

        <a-tab-pane tab="我的课程" key="2">
          <myCourse></myCourse>
        </a-tab-pane>

        <a-tab-pane tab="我的订单" key="3">
          <myOrder></myOrder>
        </a-tab-pane>
        <a-tab-pane v-if="userInfo.memberFlag!=0" tab="我的会员" key="4">
          <memberEquity :center-display="true"/>
        </a-tab-pane>

      </a-tabs>
      <div style="clear: both"></div>
    </div>


  </div>
</template>

<script>
import {getUserInfo} from "@api/personal-api"
import {logout, changePassworfSendCode} from "@api/personal-api"
import {updateUserInfo} from "@api/personal-api"
import {vcode} from "@api/personal-api"
import {updateUserMobile} from "@api/personal-api"
import {originalPasswordModify, phoneModifyPasswordModify} from "@api/personal-api"
import {updateUserAvatar} from "@api/personal-api"
import myOrder from "@components/order/MyOrder"
import myCourse from "@components/personal/MyCourse"
import common from "../mixin/common"
import {DISPATCH_INIT_USER_INFO} from "@constants/action-type/login-action-type";
import {showError, showMsg, showWaringMsg, showSuccessMsg} from "@utils/msg";

import defaultImg from '../assets/img/null.jpg'
// import {mapState} from "vuex";
import {systemDictText} from "@api/course-live-online";
import {memberDisplay} from "@utils/common";
import memberEquity from "@views/member-equity/index.vue";
// //上传头像
// function getBase64(img, callback) {
//     const reader = new FileReader();
//     reader.addEventListener('load', () => callback(reader.result));
//     reader.readAsDataURL(img);
// }
export default {
  name: "personal",
  mixins: [common],
  components: {

    myOrder,
    // CourseListItem,
    myCourse,
    memberEquity
  },
  data() {
    return {
      showServiceNum: false,
      //移动端
      isPhone: false,
      activeKey: '1',
      current: "1",
      choiceCour: "a",
      tabPosition: 'left',
      top: "top",
      //是否有正在学习内容
      isHaveMyStudyList: false,
      //正在学习
      myStudyList: [],
      // 是否有观看记录
      isHaveRecordList: false,
      //观看记录
      recordList: [],
      //我的收藏列表
      isHaveCollectList: false,
      collectList: [
        {
          coverFileUrl: "https://10.url.cn/qqcourse_logo_ng/ajNVdqHZLLDQ0DMIoUUz0onEVqqXWOw3GSPklZGXJBR2y5NW6bF48HMzuIkWCdDMNL9qETiceRY4/356",
          courseSubtitle: "介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍介绍",
          participationsCount: 21,
          coursePrice: 666
        }
      ],
      //是否请求到用户信息
      isHaveUserInfo: false,
      //    用户信息
      userInfo: {},
      //    用户信息
      newUserInfo: {
        mobile: "",
        code: "",
        nickname: "",
        sex: 0,
        email: "",
        oldPassword: "",
        newPassword: "",
        checkNewPassword: "",
      },

      //    控制弹窗
      ModalText: '修改昵称',
      cancelText: "取消",
      okText: "确认",
      // visible: false,
      confirmLoading: false,
      showNickname: false,
      showMobile: false,
      showPassword: false,
      //    验证码倒计时
      show: false,
      count: 0,
      countText: "获取验证码",
      timer: null,

      // //默认图片地址
      // defaultImg: 'this.src="' + require('../assets/img/null.jpg') + '"',
      defaultImg: null,
      //    控制上传头像
      loading: false,
      // imageUrl: "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png",
      imageUrl: "",
      headers: {
        authorization: 'authorization-text',
      },
      fileList: [],
      uploading: false,
      //   原密码修改/手机验证码修改
      isPasswordModify: true,
      //   客服qq列表数据
      qqList: [],
      //   客服电话数据
      phoneNum: ''

    }
  },
  created() {
    this.defaultImg = defaultImg
    if (this.isMobile) {
      this.isPhone = true
    }
    this.activeKey = this.$route.params.activeKey;
    this.getUserInfo()
    systemDictText('qq_list').then(res => {
      this.qqList = res.rows
    })
    systemDictText('es_phone').then(res => {
      this.phoneNum = res.rows[0]
    })
  },
  methods: {
    memberDisplay,
    copy(qq) {
      const inputNode = document.createElement("input");
      inputNode.setAttribute("value", qq);
      document.body.appendChild(inputNode);
      inputNode.select();
      document.execCommand("copy");
      document.body.removeChild(inputNode);
      this.$message.success('复制成功')
    },
    callNum() {
      window.location.href = `tel:${this.phoneNum}`
    },
    switchModifyPassword() {
      this.isPasswordModify = !this.isPasswordModify
      for (let key in this.newUserInfo) {
        this.newUserInfo[key] = ''
      }
    },
    // 获取用户信息
    getUserInfo() {
      //用户信息
      getUserInfo().then((res => {
        this.isHaveUserInfo = true
        this.userInfo = res.data

        if (res.data.avatarUrl) {
          this.imageUrl = res.data.avatarUrl
        } else {
          // this.imageUrl = ""undefined
        }
      }))
    },

    //获取验证码
    sendCode() {
      this.show = true
      let phoneChecking = /^1[3456789]\d{9}$/
      if (!phoneChecking.test(this.newUserInfo.mobile)) {
        showWaringMsg('手机号格式不正确，请重新输入！');
        this.show = false
        return false;
      } else {
        vcode(this.newUserInfo.mobile).then((res) => {
          if (res.code == 0) {
            showSuccessMsg('发送成功，注意查收并正确填写验证码');
            //    60秒倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              // this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.show = true;
                  this.count--;
                  this.countText = this.count + "s后重试"
                } else {
                  this.show = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.countText = "获取验证码"
                }
              }, 1000)
            }
          } else {
            showWaringMsg(res.msg);
            this.show = false;
            clearInterval(this.timer);
            this.timer = null;
            this.countText = "获取验证码"
          }
        })
      }
    },

    //获取验证码
    phoneSendCode() {
      this.show = true
      let phoneChecking = /^1[3456789]\d{9}$/
      if (!phoneChecking.test(this.newUserInfo.mobile)) {
        showWaringMsg('手机号格式不正确，请重新输入！');
        this.show = false
        return false;
      } else {
        changePassworfSendCode(this.newUserInfo.mobile).then((res) => {
          if (res.code == 0) {
            showSuccessMsg('发送成功，注意查收并正确填写验证码');
            //    60秒倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              // this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.show = true;
                  this.count--;
                  this.countText = this.count + "s后重试"
                } else {
                  this.show = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.countText = "获取验证码"
                }
              }, 1000)
            }
          } else {
            showWaringMsg(res.msg);
            this.show = false;
            clearInterval(this.timer);
            this.timer = null;
            this.countText = "获取验证码"
          }
        })
      }
    },
    //    退出登录
    logout() {
      //退出登录
      logout().then(res => {
        if (res.code === 0) {
          showSuccessMsg("退出成功...");
          setTimeout(() => {
            location.href = '/';
          }, 500)
        } else {
          showError("退出失败", res.msg)
        }
      });
    },
    //   弹窗
    changeNickname(a) {
      if (a == "1") {
        this.showNickname = true;
      }
      if (a == "2") {
        this.showMobile = true;
      }
      if (a == "3") {
        this.showPassword = true;
      }
    },
    //改昵称
    handleOk() {
      // this.ModalText = '操作成功，请稍等！';
      this.confirmLoading = true;
      var reg2 = /^\S{0,32}$/;
      if (this.newUserInfo.nickname == "") {
        showWaringMsg('昵称不能为空！');
        // this.visible = false;
        this.confirmLoading = false;
      } else if (!reg2.test(this.newUserInfo.nickname)) {
        showWaringMsg('昵称不能含有空格且不超过32位！！');
        this.confirmLoading = false;
      } else if (this.newUserInfo.nickname.length > 32) {
        showWaringMsg('昵称不能超过32位！');
        this.confirmLoading = false;
      } else {
        updateUserInfo(this.newUserInfo.nickname).then((res) => {
          if (res.code == 0) {
            this.getUserInfo()
            showMsg(res.msg);
            this.showNickname = false;
            this.confirmLoading = false;

            this.$store.dispatch(DISPATCH_INIT_USER_INFO)
          } else {
            showError(res.msg);
            this.confirmLoading = false;
          }
        })
      }
    },
    // 点击遮罩层或右上角叉或取消按钮的回调
    handleCancel() {
      this.showMobile = false;
      this.showPassword = false;
      this.showNickname = false;
    },
    //改手机号
    changePhone() {
      // this.ModalText = '操作成功，请稍等！';
      this.confirmLoading = true;
      if (this.newUserInfo.mobile == "" || this.newUserInfo.code == "") {
        showMsg('手机号,验证码均不能为空！');
        this.confirmLoading = false;
      } else {
        updateUserMobile(this.newUserInfo.mobile, this.newUserInfo.code).then((res) => {
          if (res.code == 0) {
            showSuccessMsg(res.msg);
            this.$store.dispatch(DISPATCH_INIT_USER_INFO)
            this.showMobile = false;
            this.confirmLoading = false;
            this.getUserInfo()
          } else {
            this.confirmLoading = false;
          }

        })
      }
    },
    //    改密码
    changePassword() {
      const {oldPassword, newPassword, checkNewPassword, mobile, code} = this.newUserInfo
      if (this.isPasswordModify) {
        if (oldPassword == '' || newPassword == '' || checkNewPassword == '') {
          showMsg('各项不能为空！')
          return
        }
        originalPasswordModify({oldPassword, newPassword, checkNewPassword}).then((res) => {
          if(res.code ===0){
            this.modifyPasswordSecuss()
          }

        })
      } else {
        if (newPassword == '' || checkNewPassword == '' || mobile == '' || code == '') {
          showMsg('各项不能为空！')
          return
        }
        phoneModifyPasswordModify({newPassword, checkNewPassword, mobile, code}).then((res) => {
          if(res.code ===0){
           this.modifyPasswordSecuss()
          }
        })
      }
    },
    modifyPasswordSecuss(){
      showSuccessMsg('修改密码成功')
      this.showPassword = false;
      for (let key in this.newUserInfo) {
        this.newUserInfo[key] = ''
      }
    },
    //    改头像
    beforeUpload() {
      return false
    },

    handleChange(info) {
      this.uploading = true;
      const isJPG = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
      if (!isJPG) {
        showWaringMsg('抱歉，您只能上传JPG或PNG文件！');
        return;
      } else {
        const isLt2M = info.file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          showWaringMsg('抱歉，图片必须小于2 MB！');
          return
        } else {
          updateUserAvatar(info.file).then(res => {
            if (res.code == 0) {
              showSuccessMsg(res.msg);
              this.imageUrl = res.userInfo.avatarUrl;
              this.loading = false;
            } else {
              showError(res.msg);
            }
            this.getUserInfo()
            this.$store.dispatch(DISPATCH_INIT_USER_INFO)
          })
        }
      }
    },
  },
  watch: {
    $route() {
      this.activeKey = this.$route.params.activeKey;
    },
    activeKey() {
      this.$router.push({
        params: {
          activeKey: this.activeKey
        }
      }).catch(e => e)
    }
  },
  computed: {
    // ...mapState({
    //   userInfo: state => state.login.userInfo
    // })
  },
}
</script>

<style scoped lang="less">
@import "../styles/course.less";

/deep/ .ant-modal-body {
  padding: 0;
}

/deep/ .ant-modal-content {
  border-radius: 15px !important;
}

.num-box {
  background: #fff;
  color: #333;
  border-radius: 12px;
  text-align: center;
  position: relative;

  .close-icon {
    width: 19px;
    position: absolute;
    bottom: -80px;
    left: calc(50% - 10px);
  }

  .contact-service {
    width: 80px;
    margin: 0 auto;
    height: 60px;
    color: #222222;
    font-size: 20px;
    text-align: center !important;
  }

  > div {
    width: 114px;
    margin: 0 auto;
    height: 52px;
    display: flex;
    align-items: center;
    color: #1590FB;
    font-family: PingFangSC-Regular, PingFang SC;
    border-bottom: 1px solid rgba(233, 236, 240, .4);

    img {
      width: 14px;
      margin-right: 8px;
    }
  }

  & > :last-child {
    border: none;
  }
}

.setting-phone-num {
  h4 {
    text-align: center;
    font-size: 15px;
    margin-bottom: 30px;
  }

  .password-modify-box {
    text-align: right;
    margin-right: 20px;
    font-size: 15px;
    color: #00B278;
  }

  .phone-num-box {
    position: relative;

    button {
      position: absolute;
      right: 20px;
      top: 10px;
      background: transparent;
      border: none;
      font-size: 15px;
      color: #00B278;
      box-shadow: none;
    }
  }

  .phone-setting-footer {
    margin-top: 10px;
    text-align: center;

    button {
      width: 110px;
      height: 43px;
      border-radius: 24px;
      font-size: 17px;
      background: #fff;
      border: 1px solid #D1D4D8;
      font-weight: 500;
    }

    & > :nth-child(2) {
      background: #00B278;
      color: #fff;
      margin-left: 19px;
    }
  }

  span {
    border: none;
    height: 48px;
    border-radius: 24px;
    padding-left: 16px;
    margin-bottom: 15px;

    input {
      padding: 0 !important;
      border: none !important;
    }
  }

  input {
    border: none;
    height: 48px;
    background: #F8F9FA;
    border-radius: 24px;
    padding-left: 16px;
    margin-bottom: 15px;
  }
}

/deep/ .ant-skeleton-paragraph {
  li {
    height: 30px;
  }
}

.mobile-header {
  width: 100%;
  height: 182px;
  background: url("~@assets/img/person/person-center-bg.png");
  background-size: 100% 100%;
  padding: 27px 24px 0 24px;
  font-weight: 500;
  color: #333;

  .avatar-name-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .avatar {
      display: flex;
      align-items: center;

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 9px;
      }
    }

    .custom-service {
      width: 88px;
      height: 31px;
      border-radius: 3px;
      border: 1px solid #00B278;
      font-size: 13px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #00B278;

      > img {
        width: 16px;
        margin-right: 3px;
      }
    }
  }

  .member-msg-box {
    margin-top: 27px;
    padding: 8px 5px 0;
    height: 88px;
    background-image: url("~@assets/img/person/member-bg.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 12px;
    img {
      width: 27px;
    }

    > button {
      width: 75px;
      height: 26px;
      background: linear-gradient(131deg, #FFEFE5 0%, #FFB991 100%);
      border-radius: 13px;
      font-weight: 600;
      color: #A7461B;
      font-size: 12px;
      border: none;
    }

    .member-prerogative {
      font-size: 12px;
      & > :nth-child(1) {
        //font-size: 13px;
        color: #fff;
        margin-bottom: 4px;
      }

      & > :nth-child(2) {
        font-size: 12px;
        color: #abafba;
        margin-bottom: 4px;
      }

    }
  }
}

.bottom-container {
  padding: 24px;

  .setting-box {
    height: 70px;
    border-bottom: 1px solid #E9ECF0;
    display: flex;
    align-items: center;

    > div {
      width: 100%;
      display: flex;
      align-items: center;
    }

    img {
      width: 16px;
      margin-right: 9px;
    }

    i {
      margin-left: auto;
    }
  }

  > button {
    width: 100%;
    height: 43px;
    background: #F3F3F3;
    border-radius: 3px;
    border: none;
    color: #FF5C7A;
    font-size: 15px;
  }
}

.personal {
  background: #F4F4F4;
  padding: 20px 10px;
  overflow: hidden;

}

.mobile-personal {
  padding: 0;

  .phone-personal {
    background: #f4f4f4;
    min-height: calc(100vh - 50px);

    /deep/ .ant-tabs-nav-scroll {
      padding-left: 20px;
    }
  }

}


.box {
  margin-top: 15px;
  background: white;
  border-radius: 10px;
  margin-bottom: 15px;
  padding: 20px;

  .leftbox {
    float: left;
    width: 200px;
  }
}

header {
  font-size: 22px;
}

.myInformation {
  padding: 40px;
  font-size: 20px;
  color: #333333;
  line-height: 40px;

  a {
    font-size: 14px;
    color: #00CF8C;
  }

  .informationList {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
  }
}

.chapter {
  display: inline-block;
  width: 300px;
  height: 500px;
  overflow: scroll;
  background: #131313;
  color: #999999;
  padding: 20px;

  .chapter-title {
    font-size: 18px;
  }

  li {
    margin: 10px 0;

    .chapter-name {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }

    .chapter-time {
      text-indent: 44px;
    }
  }

  span:nth-of-type(1) {
    display: inline-block;
    font-size: 12px;
    width: 40px;
    height: 16px;
    color: white;
    text-align: center;
    background: #999999;
  }

}

.course-bottom {
  padding: 20px;

  .course-catalog {
    h3 {
      font-size: 22px;
      margin: 10px 0;
    }

    dt {
      height: 50px;
      line-height: 30px;
      padding: 10px 20px;
      background: #F2F2F2;
      margin: 10px 0;

      .ant-btn {
        height: 30px;
        float: right;
      }

      .anticon {
        font-size: 16px;
        margin: 0 10px 0 0;
      }
    }
  }

  .commentDetail {
    p {
      padding: 6px 40px;

      dt {
        padding: 20px 0;
      }
    }

    .commentDetail-time {
      color: #999999;
    }

  }
}

@import '../styles/variable.less';

@media screen and (max-width: @screen-lg) {

  /deep/ .ant-tabs {
    min-height: calc(100vh - 70px);
  }

  /deep/ .ant-tabs-left-bar {
    display: none;
  }

  /deep/ .ant-tabs-left-content {
    border-left: 0px solid #F4F4F4;
    padding: 0;
  }

  header {
    font-size: 18px;
  }

  .chapter-title {
    font-size: 16px;
  }

  .myInformation {
    padding: 10px;
    font-size: 18px;
    line-height: 30px;

    .informationList {
      font-size: 16px;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
  }
}


</style>
